// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";
// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## GET Requests

/**
 * Paraşütten bölge listesini getirir
 * @param {{params: object, query: object}} option
 * @returns {Promise}
 */
export const GetRegions = async (option) => {
  const response = await $api.get(Endpoints.ParasutSync.GetRegions(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Paraşütten müşteri listesini getirir
 * @param {{params: object, query: object}} option
 * @returns {Promise}
 */
export const GetCustomers = async (option) => {
  const response = await $api.get(Endpoints.ParasutSync.GetCustomers(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Paraşütten çalışan listesini getirir
 * @param {{params: object, query: object}} option
 * @returns {Promise}
 */
export const GetEmployees = async (option) => {
  const response = await $api.get(Endpoints.ParasutSync.GetEmployees(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Paraşütten ürün listesini getirir
 * @param {{params: object, query: object}} option
 * @returns {Promise}
 */
export const GetProducts = async (option) => {
  const response = await $api.get(Endpoints.ParasutSync.GetProducts(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Paraşütten ürün kategori listesini getirir
 * @param {{params: object, query: object}} option
 * @returns {Promise}
 */
export const GetProductCategories = async (option) => {
  const response = await $api.get(
    Endpoints.ParasutSync.GetProductCategories(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Paraşütten kasa ve banka listesini getirir
 * @param {{params: {parasutAccountId: string}, query: object}} option
 * @returns {Promise}
 */
export const GetAccounts = async (option) => {
  const response = await $api.get(Endpoints.ParasutSync.GetAccounts(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## POST Requests - Transfer Operations

/**
 * Paraşütten alınan müşterilerin transferini sağlar
 * @param {object} form Transfer edilecek data
 * @param {{params: {parasutAccountId: string}, query: object}} option
 * @returns {Promise}
 */
export const TransferCustomers = async (form, option) => {
  const response = await $api.post(
    Endpoints.ParasutSync.TransferCustomers(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Paraşütten alınan çalışanların transferini sağlar
 * @param {object} form Transfer edilecek data
 * @param {{params: {parasutAccountId: string}, query: object}} option
 * @returns {Promise}
 */
export const TransferEmployees = async (form, option) => {
  const response = await $api.post(
    Endpoints.ParasutSync.TransferEmployees(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Paraşütten alınan ürünlerin transferini sağlar
 * @param {object} form Transfer edilecek data
 * @param {{params: {parasutAccountId: string}, query: object}} option
 * @returns {Promise}
 */
export const TransferProducts = async (form, option) => {
  const response = await $api.post(
    Endpoints.ParasutSync.TransferProducts(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Paraşütten alınan ürün kategorilerinin transferini sağlar
 * @param {object} form Transfer edilecek data
 * @param {{params: {parasutAccountId: string}, query: object}} option
 * @returns {Promise}
 */
export const TransferProductCategories = async (form, option) => {
  const response = await $api.post(
    Endpoints.ParasutSync.TransferProductCategories(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Paraşütten alınan bölgelerin transferini sağlar
 * @param {object} form Transfer edilecek data
 * @param {{params: {parasutAccountId: string}, query: object}} option
 * @returns {Promise}
 */
export const TransferRegions = async (form, option) => {
  const response = await $api.post(
    Endpoints.ParasutSync.TransferRegions(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  // GET metodları
  GetRegions,
  GetCustomers,
  GetEmployees,
  GetProducts,
  GetProductCategories,
  GetAccounts,

  // POST metodları
  TransferCustomers,
  TransferEmployees,
  TransferProducts,
  TransferProductCategories,
  TransferRegions,
};
